import { createSelector } from 'reselect';
export const getTemplateItems = createSelector([(state) => state.config.templates], (templates) => {
    if (!templates) {
        return [];
    }
    return Object.keys(templates).map((t) => {
        return {
            value: t,
            label: templates[t].label,
        };
    });
});
//# sourceMappingURL=selectors.js.map